import * as types from "./actiontypes"

const initialState = {
    loginData: null,
    massage: null,
    userDetail:[],
    isLoading: false,
    isError: false
}

export const Authreducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.REGISTRATION_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.REGISTRATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                massage: payload
            }

        case types.REGISTRATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                // massage: ""
            }

        case types.LOGIN_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                loginData: payload
            }

        case types.LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                loginData: null
            }

            case types.GET_USER_REQUEST:
                return {
                    ...state,
                    isLoading: true,
                    isError: false
                }
    
            case types.GET_USER_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    isError: false,
                    userDetail: payload
                }
    
            case types.GET_USER_FAILURE:
                return {
                    ...state,
                    isLoading: false,
                    isError: true,
                }


        default:
            return state
    }
}